// extracted by mini-css-extract-plugin
export default {"backdrop":"nameInputModal_backdrop__C6lwj","modalBox":"nameInputModal_modalBox__N9VJ3","label":"nameInputModal_label__qwn86","buttonRow":"nameInputModal_buttonRow__NFT74"};